import { Settings } from "@mui/icons-material";
import { Box, Container } from "@mui/material";
import GlobalNavigation from "../../components/GlobalNavigation";
import Header from "../../components/Header";
import Helmet from "../../components/Helmet";
import Layout, {
  LayoutStateProvider,
  SidebarSwitch,
  SideSheetTrigger,
} from "../../components/Layout";
import Loading from "../../components/Loading";
import SettingsDrawer from "../../components/SettingsDrawer";
import { useExtraction } from "../../domain/crud";
import { useExtractionParams } from "../../paths";
import { selectData } from "../../utils";
import { CreateExtractionTopicForm } from "./components/CreateExtractionTopicForm";

export function NewExtractionTopic() {
  const { extractionId } = useExtractionParams();

  const extractionQuery = useExtraction(extractionId, { select: selectData });

  return (
    <>
      <Helmet>
        <title>New Extraction Topic</title>
      </Helmet>
      <LayoutStateProvider>
        <Layout
          header={
            <Header
              title="New Extraction Topic"
              actions={
                <SideSheetTrigger
                  title="Settings"
                  sidebarId="settings"
                  icon={<Settings />}
                />
              }
            />
          }
          globalNavigation={<GlobalNavigation />}
          sideSheet={
            <SidebarSwitch
              config={[
                {
                  id: "settings",
                  element: <SettingsDrawer />,
                },
              ]}
            />
          }
        >
          <Box sx={{ flexGrow: 1, minWidth: 0, overflowY: "auto", py: 4 }}>
            <Container fixed>
              {extractionQuery.isSuccess ? (
                <CreateExtractionTopicForm extraction={extractionQuery.data} />
              ) : (
                <Loading type="circular" />
              )}
            </Container>
          </Box>
        </Layout>
      </LayoutStateProvider>
    </>
  );
}
